import { render, staticRenderFns } from "./HerbEdit.vue?vue&type=template&id=1e3d9680&scoped=true"
import script from "./HerbEdit.vue?vue&type=script&lang=js"
export * from "./HerbEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d9680",
  null
  
)

export default component.exports